// extracted by mini-css-extract-plugin
module.exports = {"chat-messages":"chat-messages_chat-messages__2Q6gP"};